import React, { useEffect, useState } from "react";
import "./ValidSchool_Id.css";
import axios from "../../../axios";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

export default function ValidSchool_Id() {
  const navigate = useNavigate();

  const [registerState, setRegisterState] = useState({
    schoolid: "",
    schoolCode: "",
  });
  const [isVailidated, setIsValidated] = useState();

  const handleSubmit = async (e) => {
    e.preventDefault();

    localStorage.clear();
    let newUser = {
      school_assigned_id: registerState.schoolid,
      school_code: registerState.schoolCode,
    };
    try {
      const res = await axios.post(
        `/api/v1/teacherAuth/validateShoolAssignedId`,
        newUser,
      );

      let tokenInput = {
        userid: newUser.school_code + "_" + newUser.school_assigned_id,
      };
      // const tokenRes = await axios.post(
      //   `/api/v1/accessToken/create`,
      //   tokenInput
      // );
      // if (tokenRes) {
      //   localStorage.setItem(
      //     "School_id",
      //     JSON.stringify(res?.data?.data?.school_assigned_id)
      //   );
      //   localStorage.setItem(
      //     "AuthToken",
      //     JSON.stringify(tokenRes.data?.data?.token)
      //   );
      // }
      // console.log(res);
      // console.log(res);
      localStorage.setItem("schoolAssignedId", registerState?.schoolid);
      localStorage.setItem("schoolCode", registerState?.schoolCode);

      if (res?.data?.status === "Not-Registered") {
        navigate("/Register");
      } else if (res?.data?.status === "Registered") {
        navigate("/LoginWithMpin");
      }

      // res?.data?.status === "Not-Registered" &&
      //   window.location.replace("/Register");
      // res?.data?.status === "Registered" &&
      //   window.location.replace("/LoginWithMpin");

      // for error msg setState

      setIsValidated(res.data);

      // store in local storage  first store value in variable
      const dataName = res?.data?.data?.name;
      const dataSchoolId = res?.data?.data?.school_assigned_id;
      const dataMobileno = res?.data?.data?.mobile_number;
      const dataemail = res?.data?.data?.personal_email;
      // seond store in local storage
      localStorage.setItem("UserName", JSON.stringify(dataName));
      localStorage.setItem("School_id", JSON.stringify(dataSchoolId));
      localStorage.setItem("Mobile_no", JSON.stringify(dataMobileno));
      localStorage.setItem("Email", JSON.stringify(dataemail));
      localStorage.setItem("schoolCodeForTeacher", registerState.schoolCode);
    } catch (error) {
      // const dataName = error?.response?.data?.data?.name;
      // const dataSchoolId = error?.response?.data?.data?.user_id;
      // const dataMobileno = error.response?.data.data.mobile_number;
      // const dataemail = error.response?.data.data.email;

      console.log(error);

      setIsValidated(error?.response?.data);
      // console.log(setIsValidated)
    }
  };

  return (
    <div>
      <div className="d-md-flex ContainerMain  p-md-2 ">
        <img
          className="side_img_main col-lg-3 col-md-5  p-0"
          src="/Register-img/baner_img.jpg"
          alt="banner img"
        ></img>

        <form className="sub_container col-lg-9 col-md-7" autoComplete="on">
          <div>
            <div className="mb-4 valid_inner_box">
              <div>
                <img
                  className="logo_main"
                  src="/AppLogo.png"
                  alt="register logo"
                ></img>
              </div>

              <div className="regist_title">Get Started</div>

              <div>
                <input
                  className="IP_schoolId"
                  required
                  placeholder="School Code"
                  autoComplete="School Code"
                  name="School Code"
                  onChange={(e) =>
                    setRegisterState({
                      ...registerState,
                      schoolCode: e.target.value.trim(),
                    })
                  }
                />
              </div>

              <div>
                <input
                  className="IP_schoolId"
                  required
                  autoComplete="Login ID"
                  placeholder="Login ID"
                  name="Login ID"
                  onChange={(e) =>
                    setRegisterState({
                      ...registerState,
                      schoolid: e.target.value.trim(),
                    })
                  }
                />
              </div>
              {/* error msg show */}
              {!isVailidated?.status && (
                <div className="error_schoolId">{isVailidated?.message}</div>
              )}

              <div>
                <input
                  className={
                    registerState.schoolid === "" ||
                    registerState.schoolCode === ""
                      ? "Continue_btn_disabled"
                      : "Continue_btn"
                  }
                  type="submit"
                  value="Continue"
                  onClick={handleSubmit}
                  disabled={
                    registerState.schoolid === "" ||
                    registerState.schoolCode === ""
                  }
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
